import { FC } from 'react';

import './BubbleWithText.scss';

interface BubbleWithTextProps {
    content: string | number;
}

export const BubbleWithText: FC<BubbleWithTextProps> = ({ content }) => (<div className="bubble-with-text">{content}</div>)